module.exports = __webpack_public_path__ + "assets/img/img-output-sample.474f70d4.png";